import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PostCard from './PostCard';
import { QuillStyles } from '../quillConfig';

/**
 * Shared component for displaying a grid of post cards
 * Used on both homepage and AI Notes page to ensure consistent rendering
 */
const PostGrid = ({ posts }) => {
  if (!posts || posts.length === 0) {
    return null;
  }

  return (
    <>
      <QuillStyles />
      <Row className="g-4" style={{ marginBottom: '100px' }}>
      {posts.map((post) => (
        <Col key={post.id} xs={12} md={6} lg={4}>
          <PostCard post={post} />
        </Col>
      ))}
      </Row>
    </>
  );
};

export default PostGrid;

